"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockPreviewVoiceRoute = void 0;
const utils_1 = require("../utils");
const enums_1 = require("../../utilities/enums");
const base = Object.assign({ id: 1, organization_id: 3, inbound_voice_trunk_id: null, outbound_voice_trunk_id: null, number: '+4618181818', provider: enums_1.VoiceRoutePhonenumberProviderEnum.CONNECTEL, terminated_by: null, terminates_at: null, terminated_at: null, description: 'test', inbound_journey_id: 1 }, utils_1.mockDateObject);
exports.mockPreviewVoiceRoute = (0, utils_1.mockFunction)(Object.assign({}, base));
